import { Component, Input } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { InputFormFieldComponent } from 'app/shared/components/forms/fields/input-form-field/input-form-field.component';
import { Patterns } from 'app/shared/enums/patterns.enum';
import { HelperService } from 'app/shared/services/helper.service';

const TYPES: any[] = [
  { typeId: 0, value: 'UsefulLinksUsedInResearch' },
  { typeId: 1, value: 'SystemLinkSMA' },
  { typeId: 2, value: 'SystemLinkPINexus' },
  { typeId: 3, value: 'SystemLinkNCRNexus' },
  { typeId: 4, value: 'SystemLinkPARS' },
  { typeId: 5, value: 'SystemLinksOther' },
];

@Component({
  selector: 'app-case-links',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterModule,
    InputFormFieldComponent,
    TranslateModule
  ],
  templateUrl: './case-links.component.html',
  styleUrl: './case-links.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class CaseLinksComponent {
  @Input() editMode!: boolean;

  form: any;
  types = TYPES;
  linksPerGroup = 2;
  linksRows: number[] = Array.from({ length: this.linksPerGroup }, (_, i) => i + 1);
  errors: any = {};

  constructor(
    public mainForm: FormGroupDirective,
    private helperService: HelperService
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('links', new FormGroup({}));

    this.types.forEach(type => {
      this.linksRows.forEach(row => {
        this.form.get('links').addControl(`${type.value}${row}`, new FormGroup({
          id: new FormControl(0, []),
          isActive: new FormControl(false),
          isChanged: new FormControl(false),
          type: new FormControl(type.value, []),
          title: new FormControl(null, []),
          url: new FormControl(null, [Validators.pattern(Patterns.URL)]),
        }));

        this.errors[`${type.value}${row}title`] = '';
        this.errors[`${type.value}${row}url`] = '';
      });
    });

  }

  onInputChange(group: string, row: number) {
    this.helperService.handleLinksErrors(group, row, this.form, this.errors);
  }

  getFormControlByGroupRowAndControlName(group: string, row: number, controlName?: string) {
    return this.form.get(`links.${group}${row}${controlName ? '.'+controlName : ''}`);
  }

  navigateTo(url: string) {
    window.open(url, '_blank');
  }

}
